<template>
  <div class="min-h-screen bg-home">
    <img src="@/assets/IPL-Banner-2026.png" alt="" class="mx-auto  w-full object-fill">
    <img src="@/assets/subtract.svg" class="mx-auto w-full -mt-12 curved-background"/>
    <div class="bg-light" >
      <h1 class="text-2xl text-white  font-bold text-center pt-20 pb-2">Today’s Match</h1>
    </div>
    <div class="p-4 -mt-32 matches-section">
      <template v-if="matches && matches.length > 0" >
        <MatchCard v-for="match in matches" :key="match.id" :match="match" />
      </template>
      <div v-if="!matches || matches.length === 0" class="text-sm text-white  font-bold text-center pb-2 mx-auto"> No Matches Today</div>
      <!-- Tomorrow Matches -->
      <h1 class="text-2xl text-white  font-bold text-center pt-5 pb-2">Tomorrow's Match</h1>
     <template v-if="tomorrowMatches && tomorrowMatches.length > 0" >
        <MatchCard v-for="match in tomorrowMatches" :key="match.id" :match="match" />
      </template>
      <div v-if="!tomorrowMatches || tomorrowMatches.length === 0" class="text-sm text-white  font-bold text-center pb-2 mx-auto"> No Matches Tomorrow</div>
      <div class="pt-6" v-if="showPrediction()">            
       <PredictWinner :winner="contest" />
      </div>
      <!-- my Score -->
      <MyScoreCard :scoreCard="myScoreCard" />
      <ScoreBoard :weeklyScorers="weeklyScorers" :topScorers="topScorers" :teamScorers="teamScorers" />
    </div>
    <div class="bg-footer p-5">
      <img src="@/assets/pp-logo-white.svg" alt="" class="mx-auto mt-16 mb-12">
      <router-link to="/login" @click.native="logout" class="logout-link text-white text-opacity-70 text-sm font-medium text-center block mb-10">Logout</router-link>
    </div>
    <Loader v-if="isLoading"/>
  </div>
</template>

<script>
  import Loader from '../components/Loader.vue';
  export default {
    name: 'Home',
    components:{
      MatchCard:()=>import(/* webpackChunkName: "Match" */'../components/Matches/Card.vue'),
      Loader,
      MyScoreCard:()=>import(/* webpackChunkName: "MyScoreCard" */'../components/ScoreCards/MyScoreCard.vue'),
      ScoreBoard: ()=>import(/*webpackChunkName: "ScoreBoard"*/'../components/ScoreCards/ScoreBoard.vue'),
      PredictWinner: ()=>import(/*webpackChunkName: "PredictWinner"*/'../components/Matches/PredictWinner.vue')
    },
    data(){
      return{
        isLoading : false,
        matches : [],
        tomorrowMatches:[],
        myScoreCard: {},
        weeklyScorers:[],
        topScorers:[],
        teamScorers:[],
        timerInterval: null,
        timerCount: 0,
        contest:null
      }
    },
    async mounted(){
      this.isLoading = true;
      const apiCalls =  [this.loadMatches(),this.loadTomorrowMatches(),this.loadScoreboard(),this.loadMyScores(),this.loadPredictWinner()];
      await Promise.all(apiCalls);
      this.isLoading = false;
      if((this.matches && this.matches.length > 0) || (this.tomorrowMatches && this.tomorrowMatches.length > 0)|| this.showPrediction()){
        let upcomingMatches= this.matches && this.matches.filter(match=>!!match.starts_in && match.can_predict);
        upcomingMatches = upcomingMatches ? upcomingMatches : [];
        const tomorrowCount = this.tomorrowMatches ? this.tomorrowMatches.length: 0;
        this.timerCount = upcomingMatches.length + tomorrowCount;
        if(this.showPrediction()){
          this.contest.completed = false;
          this.timerCount++;
        }
        if(this.timerCount > 0){
          this.timerInterval = setInterval(()=>{
            //load today matches
            this.matches = this.matches.map(match => ({...(!!match.starts_in && match.can_predict?this.setTimer(match):match)}));
            //load tomorrow matches
            if(this.tomorrowMatches && this.tomorrowMatches.length > 0){
              this.tomorrowMatches = this.tomorrowMatches.map(match => ({...(!!match.starts_in && match.can_predict?this.setTimer(match):match)}));  
            }
            //load predict contest
            if(this.showPrediction() && !this.contest.completed){
              this.setContestTimer();
            }
            if(this.timerCount <= 0){
              clearInterval(this.timerInterval);
              this.timerInterval='';
            }
          },1000);  
        }  
      }
      
    },
    beforeUnmount(){
      if(this.timerInterval){
        clearInterval(this.timerInterval);
        this.timerInterval='';
      }
    },
    methods:{
      async loadMatches(){
        try{
          const res = await this.$axios.get('/ipl/matches/todays_match');
          const data = res.data;
          this.matches = data && data.length > 0 ? data :[];
        }catch(err){
          console.log(err);
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }else if(err){
            this.$swal("Loading Failed","Something went wrong!","error");
          }
        }
      },
      async loadTomorrowMatches(){
        try{
          const res = await this.$axios.get('/ipl/matches/tomorrows_match');
          const data = res.data;
          this.tomorrowMatches = data && data.length > 0 ? data :[];
        }catch(err){
          console.log(err);
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }else if(err){
            this.$swal("Loading Failed","Something went wrong!","error");
          }
        }
      },
      async loadScoreboard(){
        try{
          const res = await this.$axios.get('/ipl/matches/score_dashboards');
          const data = res.data;
          this.topScorers = data.overall_top_scorer ? data.overall_top_scorer : [];
          this.weeklyScorers = data.weekly_top_scorer ? data.weekly_top_scorer : [];
          this.teamScorers = data.team_scores ? data.team_scores.map(score => ({user_name:score.department_name,...score})) : [];
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }else if(err){
            this.$swal("Loading Failed","Something went wrong!","error");
          }
        }
      },
      async loadPredictWinner(){
        try{
          const res = await this.$axios.get('/ipl/contests/live');
          const data = res.data;
          const contest_data = data && data.contest ? data.contest:'';
          if(contest_data && contest_data.start_time){
            const current_date = new Date().getTime();
            if(new Date(contest_data.start_time).getTime() <= current_date && current_date < new Date(contest_data.end_time).getTime() ){
              contest_data.can_predict = true;
            }
          }
          this.contest= contest_data;
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }else if(err){
            this.$swal("Loading Failed","Something went wrong!","error");
          }
        }
      },
      async loadMyScores(){
        try{
          const res = await this.$axios.get('/ipl/matches/my_scores');
          const data = res.data;
          this.myScoreCard = data;
        }catch(err){
          if(err && err.data && err.data.message){
            this.$swal("Loading Failed",err.data.message,"error");
          }else if(err){
            this.$swal("Loading Failed","Something went wrong!","error");
          }
        }
      },
      setTimer(match){
        const current = new Date().getTime();
        const match_time = new Date(match.starts_in).getTime();
        const time_diff = match_time - current;
        if(time_diff <=0){
          match.match_remaining_time='';
          match.get_status = "Live";
          match.can_predict = false;
          this.timerCount--;
          return match;
        }
        let seconds = Math.floor(time_diff/1000);
        let minutes = Math.floor(seconds/60);
        let hours = Math.floor(minutes/60);
        let days = Math.floor(hours/24);
        hours = hours-(days*24);
        minutes = minutes-(days*24*60)-(hours*60);
        seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
        match.match_remaining_time = `${days?days + ' days ':''}${hours?hours + ' hrs ':''}${minutes? minutes + ' min ':''}${seconds?seconds + ' seconds':''}`;
        return match;
      },
      setContestTimer(){
        const current = new Date().getTime();
        const start_time = new Date(this.contest.start_time).getTime();
        const end_time = new Date(this.contest.end_time).getTime();
        const time_diff = start_time - current;
        const end_diff = current - end_time;

        if(time_diff <=0 && end_diff < 0){
          let seconds = Math.floor(-end_diff/1000);
          let minutes = Math.floor(seconds/60);
          let hours = Math.floor(minutes/60);
          let days = Math.floor(hours/24);
          hours = hours-(days*24);
          minutes = minutes-(days*24*60)-(hours*60);
          seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
          const closing_time = `${days?days + ' days ':''}${hours?hours + ' hrs ':''}${minutes? minutes + ' min ':''}${seconds?seconds + ' seconds':''}`;
          this.contest = {
            ...this.contest,
            match_remaining_time:'',
            match_closing_time:closing_time,
            can_predict:!!closing_time,
            completed:!closing_time
          }
          return;
        }else if(time_diff <=0 && end_diff >= 0){
          this.contest = {
            ...this.contest,
            match_closing_time:'',
            can_predict:false,
            completed:true
          }
          this.timerCount --;
          return;
        }
        let seconds = Math.floor(time_diff/1000);
        let minutes = Math.floor(seconds/60);
        let hours = Math.floor(minutes/60);
        let days = Math.floor(hours/24);
        hours = hours-(days*24);
        minutes = minutes-(days*24*60)-(hours*60);
        seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
        this.contest={
          ...this.contest,
          match_remaining_time: `${days?days + ' days ':''}${hours?hours + ' hrs ':''}${minutes? minutes + ' min ':''}${seconds?seconds + ' seconds':''}`
        }
      },
      async logout(){
        try{
          this.isLoading = true;
          await this.$axios.delete('/logout');
          localStorage.removeItem('ipl-user-name');
          localStorage.removeItem('ipl-user-token');
          localStorage.removeItem('ipl-user-name');
          this.isLoading = false;
          this.$router.replace("/login")
        }catch(err){
          this.isLoading = false;
          if(err && err.data && err.data.message){
            this.$swal("Logout Failed",err.data.message,"error");
          }else{
            this.$swal("Logout Failed","Something went wrong!","error");
          }
        }

      },
      showPrediction(){
        return this.contest && this.contest.id && new Date(this.contest.end_time).getTime() > new Date().getTime() && !this.contest.completed;
      }
    }
  }
</script>
<style scoped>
  .bg-home {
    background: #000B21;
    position: relative;
    mix-blend-mode: multiply;

  }

  .bg-home::after {
    position: absolute;
    content: '';
    background: url(../assets/bg-home.jpg) repeat-x bottom;
    height: 100%;
    width: 100%;
    bottom: 280px;
    left: 0;
    z-index: -2;
    background-size: contain;
  }

  .bg-footer {
    background: url(../assets/bg-login-full.jpg) no-repeat bottom;
    background-size: cover;
    height: 300px;
    margin-top: -15px;
  }

  .bg-gradient-blue {
    background: linear-gradient(180deg, #3C8AD2 0%, #3F6AB2 100%);
  }

  .bg-light {
    background: url(../assets/bg-light.png) no-repeat top center;
    min-height: 250px;
    background-size: cover;
    z-index: -1;
    position: relative;
  }

  .logout-link:active{
    @apply text-orange
  }
 
  @media (min-width: 640px) {
    .bg-light {
      top:-30px;
    }
    .matches-section{
      @apply -mt-40
    }
  }
  @media (max-width: 330px) {
    .curved-background{
      @apply -mt-10
    }
  }

  @media (min-width: 480px) {
    .curved-background{
      @apply -mt-16
    }
  }
  @media (min-width: 612px) {
    .curved-background{
      @apply -mt-20
    }
  }

  .btn-login {
    background: linear-gradient(180deg, #FF9C59 0%, #ED6C15 100%);
    -webkit-tap-highlight-color:transparent;
    box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
  }

  .btn-login.disabled{
    background: linear-gradient(180deg, #FF9C5999 0%, #ED6C1599 100%);
    box-shadow: none;
  }
  .btn-login:active{
    outline: none;
    box-shadow: none;
  }
</style>
